$(document).ready(function () {
    $(".select-variant-addon").change(function(){
        $(this).parents(".addon-product-variants").siblings(".buy-btn-style--addToCart").find("input.product-variant-id").attr('value', $(this).attr('variant-id'));
        $(this).parents(".addon-product-variants").parents(".variant-selector-addToCart").siblings(".custom-buy-btn-parent").find("input.product-variant-id").attr('value', $(this).attr('variant-id'));
        var addonPrice = $(this).attr('data-price');
        if (addonPrice) {
            $(this).parents(".add-on-products").find(".add-on-product-price").text(addonPrice);
        }
    });
    // Sync each add-on's variant id + displayed price to its default-selected colour on load,
    // so the advertised price always matches the variant that will be added to cart.
    $(".select-variant-addon:checked").trigger("change");

    // $(".add-on-products .buy-btn-style .addToCart--btn-lg").click(function(){
    //     let var_id = parseInt($(this).parents(".buy-btn-style--addToCart").siblings(".product-form__input-css").find(".select-variant-addon:checked").attr("variant-id"));
    //     if(!var_id){
    //         var_id = $(this).attr('variant-id');
    //         console.log("empty");
    //         addItemToCart(var_id);
    //     }else{
    //         console.log(var_id);
    //         addItemToCart(var_id);
    //     }
    // });

    // $(".add-on-products .buy-btn-style .addToCart--btn-sm").click(function(){
    //     let var_id = parseInt($(this).parents(".custom-buy-btn-parent").siblings(".variant-selector-addToCart").find(".select-variant-addon:checked").attr("variant-id"));
    //     console.log(var_id);
    //     if(!var_id){
    //         var_id = $(this).attr('variant-id');
    //         console.log("empty");
    //         addItemToCart(var_id);
    //     }else{
    //         console.log(var_id);
    //         addItemToCart(var_id);
    //     }
    // });

    // // Common Cart Function
    // function addItemToCart(variant_id) {
        // $.ajax({
        //     type: "POST",
        //     url: "/cart/add.js",
        //     data: {
        //         quantity: 1,
        //         id: variant_id,
        //     },
        //     dataType: "json",
        //     success: function (data) {
        //         console.log(data);
        //         location.reload();
        //     },
        // });
    // }
    
    $(".footer .toggler-head .toggler-icon").click(function (e) { 
        e.preventDefault();
        $(this).parents(".toggler-head").siblings(".toggler-box").slideToggle();
        if($(this).text() == '+'){
            $(this).text("-");
        }else if($(this).text() == '-'){
            $(this).text("+");
        }
    });

    let selector = $(".header-wrapper .header__menu-item");
    let submenuCloseTimer;
    function closeMenuIfIdle() {
        if ($(".header-wrapper .header__menu-item:hover").length == 0 && $(".header-wrapper .submenu-wrapper:hover").length == 0) {
            $(".header-wrapper .submenu-wrapper").stop(true, true).slideUp(150);
        }
    }
    $(selector).on("mouseenter", function () {
        clearTimeout(submenuCloseTimer);
        $(this).siblings(".submenu-wrapper").stop(true, true).slideDown(150);
    });
    $(selector).on("mouseleave", function () {
        clearTimeout(submenuCloseTimer);
        submenuCloseTimer = setTimeout(closeMenuIfIdle, 250);
    });
    $(".header-wrapper .submenu-wrapper").on("mouseenter", function () {
        clearTimeout(submenuCloseTimer);
    });
    $(".header-wrapper .submenu-wrapper").on("mouseleave", function () {
        clearTimeout(submenuCloseTimer);
        submenuCloseTimer = setTimeout(closeMenuIfIdle, 250);
    });

    
    $(".qstn-box .qstn-block .qstn").click(function(){
        $(this).parents(".qstn-block").siblings(".ans").slideToggle();
        $(this).parents(".qstn-block").siblings(".bg-shadow").toggle();
        $(this).parents(".qstn-box").toggleClass("shadow");
        $(this).children(".minus, .plus").toggle();
    });

    $("variant-radios .product-form__input input[type=radio]").change(function(){
        setTimeout(() => {
            $(".show-quantity-badge").load(" .show-quantity-badge");
        }, 500);
    });

    // toggle description on mobile
    $(".open-desc").click(function (e) { 
        e.preventDefault();
        $(this).siblings(".desc-product").slideToggle();
        if($(this).children(".plus-minus").text() == '+'){
            $(this).children(".plus-minus").text("-");
        }else if($(this).children(".plus-minus").text() == '-'){
            $(this).children(".plus-minus").text("+");
        }
    });
    $(".header-submenu-tablinks").hover(function () {
        $(".header-submenu-tablinks").removeClass("active");
        $(this).addClass("active");
        let targetTab = $(this).children("span").attr("data-bs-target");
        console.log(targetTab);
        $(".header-submenu-tabcontent").removeClass("show active");
        $(targetTab).addClass("show active");
    });

    // $(".header-top-logos-bar .brand-image-wrapper").click(function (e) {
    //     e.preventDefault();
    //     let menu_id = $(this).attr("brand-menu-id");
    //     let showDefaultMenu = $(this).attr("show-default-menu");
    //     let desktop_menu = null;

    //     let mobile_menu = $(".header-top-logos-bar .mobile-dynamic-menu-list[brand-menu='" + menu_id + "']").html();
    //     $(".menu-drawer .dynamic-mobile-navigation ul").html(mobile_menu);

    //     if (showDefaultMenu == true || showDefaultMenu == 'true') {
    //         $("header .header-dynamic-menu-list").html('');
    //         $("header .header-dynamic-menu-list--original").removeClass("d-none");
    //     } else {
    //         $("header .header-dynamic-menu-list--original").addClass("d-none");
    //         desktop_menu = $(".header-top-logos-bar .desktop-dynamic-menu-list[brand-menu='" + menu_id + "']").html();
    //         $("header .header-dynamic-menu-list").html(desktop_menu);
    //     }

    //     // $(".header-menu-dynamic-item").hide();
    //     // $(".header-menu-dynamic-item[brand-menu-ref-id='" + menu_id + "']").show();

    //     $(".brand-image-wrapper").removeClass("active-image");
    //     $(this).addClass("active-image");
    // });
    // $(".header-top-logos-bar .brand-image-wrapper").first().click();

    let current_url = window.location.href;
    let current_url_without_domain = current_url.replace(window.location.origin, '').split('?')[0].split('#')[0];
    let mobileMenu = $(".menu-drawer .menu-drawer__menu has-submenu.list-menu").html();
    console.log(mobileMenu);

    function showMenuForBrand($brand) {
        let menu_id = $brand.attr("brand-menu-id");
        let showDefaultMenu = $brand.attr("show-default-menu");
        let desktop_menu = null;

        let mobile_menu = $(".header-top-logos-bar .mobile-dynamic-menu-list[brand-menu='" + menu_id + "']").html();
        $(".menu-drawer .dynamic-mobile-navigation ul").html(mobile_menu);

        if (showDefaultMenu == true || showDefaultMenu == 'true') {
            $("header .header-dynamic-menu-list").html('');
            $("header .header-dynamic-menu-list--original").removeClass("d-none");
        } else {
            $("header .header-dynamic-menu-list--original").addClass("d-none");
            desktop_menu = $(".header-top-logos-bar .desktop-dynamic-menu-list[brand-menu='" + menu_id + "']").html();
            $("header .header-dynamic-menu-list").html(desktop_menu);
        }

        $(".brand-image-wrapper").removeClass("active-image");
        $brand.addClass("active-image");
    }

    // On logo click
    // $(".header-top-logos-bar .brand-image-wrapper").on("click", function (e) {
        // e.preventDefault();
        // showMenuForBrand($(this));
    // });

    // On page load, auto-select matching brand
    let matched = false;
    $(".header-top-logos-bar .brand-image-wrapper").each(function () {
        let href = $(this).attr("href");
        if (href) {
            let href_without_domain = href.replace(window.location.origin, '').split('?')[0].split('#')[0];
            if (href_without_domain == current_url_without_domain) {
                console.log("WORKING");
            showMenuForBrand($(this));
                matched = true;
                return false; // Stop loop once matched
            }
        }
    });

    // If no matched brand found, keep default menu visible
    if (!matched) {
        $("header .header-dynamic-menu-list--original").removeClass("d-none");
        $(".menu-drawer .defualt-original-mobile-menu-link-script").removeClass("d-none");
    }
});